import classNames from 'classnames';
import React from 'react';
import { componentToBeCopiedInfo, setCopiedComponentInfo, showProperties } from '../../../store/workflow';
import { ContextMenuComponent } from '../../context-menu';
import { DsPortModel } from '../port/ds_portmodel';
import { PortWidget } from '../port/port-widget';
// import { DsNodeModel } from './ds_nodemodel';
import { DsNodeWidgetProps } from './node_component';
import { store as _store } from '../../../store';
import { TooltipTop } from '../../tooltips';
import { cloneDeep, debounce, has, range } from 'lodash';
import { getAllVariableNames } from '../../../pages/workflow-page/utils';
import { errorAlert } from '../../toastify/notify-toast';
import { createNodeTestId, handleDeleteNode } from './utils';
import { ExecutionEnvModes } from '../../../constants/enums';
import * as yup from 'yup';

const VarIcon = () => (
    <svg
        width="16px"
        height="16px"
        viewBox="0 0 24 24"
        version="1.1"
        id="ds__nodeVariable__icon"
    >
        <g
            id="Icons/Variable"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M18.1682317,14.9031476 C16.6169551,14.9031476 15.159891,14.3057968 14.0654891,13.2210878 C12.9669198,12.1322582 12.3618896,10.6786123 12.3618896,9.12803804 C12.3618896,7.02431601 13.5168835,5.08303108 15.3760836,4.0617236 C15.8295402,3.81275327 16.3987958,3.97832767 16.647813,4.43164378 C16.8968301,4.8849599 16.7312089,5.45435602 16.2778928,5.70337318 C15.0177292,6.39559217 14.2349032,7.70782549 14.2349032,9.12803804 C14.2349032,11.2796624 15.9993757,13.0301341 18.1682317,13.0301341 C20.3370878,13.0301341 22.1015603,11.2796624 22.1015603,9.12803804 C22.1015603,4.79617905 18.2439483,1.88570325 12.5023657,1.88570325 L0.936506791,1.88570325 C0.41927409,1.88570325 0,1.46642916 0,0.949196458 C0,0.431963757 0.41927409,0.012689667 0.936506791,0.012689667 L12.5023657,0.012689667 C15.8822655,0.012689667 18.7604318,0.893427478 20.8258039,2.55961353 C22.8563379,4.19775121 23.9745738,6.53044915 23.9745738,9.12803804 C23.9745738,10.6786123 23.3695436,12.1322582 22.2709743,13.2210878 C21.1765725,14.3057968 19.7195084,14.9031476 18.1682317,14.9031476 L18.1682317,14.9031476 Z M15.8269648,23.0507567 C15.8269648,22.533524 15.4076907,22.1142499 14.890458,22.1142499 L11.4722082,22.1142499 C5.73062553,22.1142499 1.87301358,19.2037741 1.87301358,14.8719151 C1.87301358,12.7202908 3.63748603,10.9698191 5.8063421,10.9698191 C7.97519818,10.9698191 9.73967062,12.7202908 9.73967062,14.8719151 C9.73967062,16.2921277 8.9568446,17.604361 7.69672788,18.29658 C7.24341177,18.5455971 7.07779055,19.1149933 7.3268077,19.5683094 C7.57582486,20.0216255 8.14517416,20.1872936 8.5985371,19.9382296 C10.4576904,18.9169689 11.6126842,16.975684 11.6126842,14.871962 C11.6126842,13.3213877 11.0077008,11.8677418 9.9090847,10.7789122 C8.81468287,9.69415639 7.35761878,9.09680554 5.8063421,9.09680554 C4.25506543,9.09680554 2.79800134,9.69415639 1.7035995,10.7789122 C0.604983387,11.8677418 0,13.3213877 0,14.871962 C0,17.4695508 1.11823593,19.8022488 3.14876996,21.4403396 C5.21409521,23.1065257 8.09230835,23.9872635 11.4722082,23.9872635 L14.890458,23.9872635 C15.4076907,23.9872635 15.8269648,23.5679894 15.8269648,23.0507567 L15.8269648,23.0507567 Z"
                id="Shape"
                fill="#6E88FF"
                fillRule="nonzero"
            />
            <path
                d="M23.0634932,23.9872635 L18.7769612,23.9872635 C18.2597285,23.9872635 17.8404544,23.5679894 17.8404544,23.0507567 C17.8404544,22.533524 18.2597285,22.1142499 18.7769612,22.1142499 L23.0634932,22.1142499 C23.5806791,22.1142499 24,22.533524 24,23.0507567 C24,23.5679894 23.5806791,23.9872635 23.0634932,23.9872635 Z"
                id="Path"
                fill="#5BC2FF"
                fillRule="nonzero"
            />
        </g>
    </svg>
);


const validateVariableName = async (variable: string, existingKeyMap: Record<string, true>) => {
    const schema = yup
            .string()
            .required("Variable name cannot be empty")
            .test({
                test: function(value) {
                    const getError = (message: string) =>
                        new yup.ValidationError(
                            message,
                            value,
                            "key"
                        );

                    if(/\s/.test(value)) {
                        return getError(`Cannot have spaces`)
                    } else if(/^\d/.test(value)) {
                        return getError(`Cannot start with a number`)
                    } else if(!/^[a-zA-Z0-9_]*$/.test(value)) {
                        return getError(`Has to be alphanumeric, only _ are allowed`)
                    } else if(has(existingKeyMap, value)) {
                        return getError(`${value} already exists, please use a different name`)
                    }	
                    return true;
                }
            })
    try {
        return await schema.validate(variable)
    } catch(e) {
        throw (e as any)?.message
    } 
}

export default class DsNodeVariable extends React.Component<DsNodeWidgetProps, {
    showRenameOptions: boolean;
    renameFieldValue: string;
    usedVariableNames: Record<string, true>;
    duplicateNameError: boolean;
    nameError: string | null;
}> {
    nodeRef: React.RefObject<HTMLDivElement>;
    contextMenuRef: React.RefObject<ContextMenuComponent>;
    constructor(props: Readonly<DsNodeWidgetProps>) {
        super(props);
        const { isMounted } = this.props.node.getOptions();
        this.state = {
            showRenameOptions: !isMounted,
            renameFieldValue: '',
            usedVariableNames: {},
            duplicateNameError: false,
            nameError: ''

        };
        this.nodeRef = React.createRef<HTMLDivElement>();
        this.contextMenuRef = React.createRef<ContextMenuComponent>();
    }


    setVariableNameAndOptions = () => {
        let varName = 'var_' ;
        const usedVariableNames = getAllVariableNames(this.props.engine.getModel());
        // assuming 100 is highest number of variables
        // varNames would be var_1, var_2, var_3
        range(1, 100).some((n) => {
            if(!usedVariableNames[varName+n]) {
                varName += n;
                return true;
            } return false;
        });
        this.props.node.getOptions().title = varName;
        this.setState({ renameFieldValue: varName, usedVariableNames }) ;
    }


    componentDidMount() {
        if(!this.props.node.getOptions().isMounted) {
            this.setVariableNameAndOptions();
            this.showRenameTitle();
            this.props.node.getOptions().isMounted = true;
        }
    }


    renderPort = (port: DsPortModel, coords: {x: number; y: number}) => (
        <PortWidget
            port={port}
            engine={this.props.engine}
            style={{ left: coords.x, top: coords.y }}
            className={classNames('ds__nodeVariable__port', {'ds__nodeVariable__port--connected': port.isPortConnected() })}
        >
            {/* <circle cx={coords.x} cy={coords.y} r="4" fill="white" /> */}
        </PortWidget>
    )
    
    
    renderInputPort = () => {
        const inputPort = this.props.node.getInPorts()[0];
        return(
            this.renderPort(inputPort, {x: 13, y: 42})
        );
    }

    renderOutputPort = () => {
        const outputPort = this.props.node.getOutPorts()[0];
        return(
            this.renderPort(outputPort, {x: 82, y: 42})
        );
    }

    saveRenameState = () => {
        if(this.state.nameError) {
            errorAlert(this.state.nameError);
        } else {
            this.props.node.getOptions().title = this.state.renameFieldValue;
            this.removeEventListenerForRename();
            this.setState({ showRenameOptions: false });
        }
        
    }

    handleClickOutsideRenameField = (event: MouseEvent) => {
        if(this.nodeRef.current && !this.nodeRef.current.contains(event.target as any)) {
            this.saveRenameState();
            // this.props.node.getOptions().title = this.state.renameFieldValue;
            // this.removeEventListenerForRename();
            // this.setState({ showRenameOptions: false });
        }
    }

    showRenameTitle = () => {
        this.setState({ showRenameOptions: true, renameFieldValue: this.props.node.getOptions().title });
        document.addEventListener('mousedown', this.handleClickOutsideRenameField);
        this.contextMenuRef.current?.hideContextMenu();
    }

    removeEventListenerForRename = () =>{ 
        document.removeEventListener('mousedown', this.handleClickOutsideRenameField);
    }

    restoreToOriginalValue = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if(e.keyCode === 27) {
            this.removeEventListenerForRename();
            this.setState({ showRenameOptions: false });
        } else if(e.keyCode === 13) {
            this.saveRenameState();
        }
    }

    handleContextMenuClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();
        this.contextMenuRef.current?.showContextMenu(e);
    }

    handleShowProperties = () => {
        _store.dispatch(showProperties() as any);
    }
    

    _validateVariableName = debounce(async(name: string) => {
        try{
            await validateVariableName(name, this.state.usedVariableNames)
            this.setState({ nameError: null  })
        } catch(error) {
            this.setState({ nameError: error as string  })
        }          
    }, 200)


    handleTitleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const renameFieldValue = e.target.value;
        this._validateVariableName(renameFieldValue);
        this.setState({ 
            renameFieldValue, 
            duplicateNameError: !!this.state.usedVariableNames[renameFieldValue] 
        });
    }

    cloneNode = () => {
        const { node } = this.props;
        const { title, subtitle, actualTitle, iconKey, isPropertiesTouched, isPropertiesValid, isPropertiesSavedAtleastOnce, hash, notes, customComponentId } = node.getOptions();
        const nodeInfo: componentToBeCopiedInfo = {
            title,
            subtitle,
            actualTitle,
            iconKey,
            isPropertiesTouched,
            isPropertiesValid,
            inputPorts: node.getInPorts().length,
            outputPorts: node.getOutPorts().length,
            details: cloneDeep(node.extras),
            nodeType: 'variable',
            // env doesnt matter for node variable
            env: ExecutionEnvModes.Spark,
            hash,
            isPropertiesSavedAtleastOnce,
            notes,
            customComponentId,
            hasVariableInputPort: node.hasVariableInputPort
        };
        _store.dispatch(setCopiedComponentInfo(nodeInfo) as any);
        this.contextMenuRef.current?.hideContextMenu();
    }
    
    deleteVariable = () => {
        handleDeleteNode(this.props.node, _store.dispatch);
        this.contextMenuRef.current?.hideContextMenu();
    }

    render() {
        const { selected, title } = this.props.node.getOptions();
        const { renameFieldValue, showRenameOptions, nameError } = this.state;

        return(
            <TooltipTop
                overlay={title}
            >
                <div
                    className={classNames('ds__nodeVariable',
                        {'ds__nodeVariable--selected': !!selected}
                    )}
                    ref={this.nodeRef}
                    onContextMenu={this.handleContextMenuClick}
                    onDoubleClick={this.handleShowProperties}
                    data-nodename={createNodeTestId(title)}
                >
                
                    <svg height="90" width="100">
                        <filter id="ds__nodeVariablePath__shadow">
                            <feDropShadow dx="0" dy="0" stdDeviation="5" floodColor="#FCAD01"/>
                        </filter>
                        {/* <path 
                            d="M60,9,96.06244584051393,23.937554159486076,111,60,96.06244584051393,96.06244584051393,60,111,23.937554159486076,96.06244584051393,9,60.00000000000001,23.93755415948607,23.937554159486076Z" fill="#0455A4" 
                            id="ds__nodeVariablePath"
                        /> */}
                        <circle cx="50"cy="45" r="36" fill="#1E2038" id="ds__nodeVariablePath" />

                        <circle cx="16"cy="45" r="6" fill="#0455A4" className="ds__nodeVariablePortBorder"/>
                        <circle cx="85"cy="45" r="6" fill="#0455A4" className="ds__nodeVariablePortBorder" />
                    </svg>
                    <div
                        className="ds__nodeVariable__portsBox"
                    >
                        <VarIcon />
                        {showRenameOptions ?
                            <div
                                className={'inputfield__container'}
                            >
                                <input 
                                    className={classNames('inputfield', {'inputfield--error': nameError })}
                                    value={renameFieldValue}
                                    onChange={this.handleTitleNameChange}
                                    onKeyDown={this.restoreToOriginalValue}
                                    autoFocus
                                />
                            </div>
                            :
                            <span
                                className="nodeVariable__title"
                            >
                                {title}
                            </span>
                        }
                        {this.renderInputPort()}
                        {this.renderOutputPort()}
                    </div>
                    <ContextMenuComponent
                        ref={this.contextMenuRef}
                        className="canvasContextMenu"
                    >
                        <button
                            onClick={this.showRenameTitle}
                        >
                            Rename
                        </button>   
                        <button
                            onClick={this.cloneNode}
                        >
                            Copy
                        </button>  
                        <button
                            onClick={this.deleteVariable}
                        >
                            Delete
                        </button>  
                    </ContextMenuComponent>
               
                </div>
            </TooltipTop>
        );
    }
    
}

